import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { ICampaignImage } from "@/interfaces/campaign.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class CampaignImageService {
  private baseUrl = "api/v1/campaignimage";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<ICampaignImage>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const campaignImages = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return campaignImages;
  }

  async filter(
    filter: IFilter<ICampaignImage>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<ICampaignImage>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async create(
    formData: FormData,
    accessToken?: string | undefined | null,
    customerId?: string | undefined
  ): Promise<FormData> {
    if (!accessToken) {
      throw new Error("Access token is undefined");
    }

    const response = await httpRequest.post(`${this.baseUrl}`, formData, {
      headers: {
        // Override default to allow Axios to set correct multipart boundary
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
        CustomerId: customerId,
      },
    });

    return response;
  }

  async getById(campaignImageId: number): Promise<ICampaignImage> {
    const campaignImage = await httpRequest.get(`${this.baseUrl}/${campaignImageId}`);
    return campaignImage;
  }

  async delete(campaignImageId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${campaignImageId}`);
  }

  async updateMainImage(campaignId: number, imageId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/main/${campaignId}/${imageId}`);
  }
}

const campaignImageService = new CampaignImageService();
export default campaignImageService;
